
/* injects from baggage-loader */

export const ERROR_GLOBAL = 'ERROR_GLOBAL'
export const ERROR_GLOBAL_RESET = 'ERROR_GLOBAL_RESET'

export default function error(state = {}, action) {
  switch (action.type) {
    case ERROR_GLOBAL:
      return {
        ...state,
        globalError: action.error
      }

    case ERROR_GLOBAL_RESET:
      return {
        ...state,
        globalError: null
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/error/index.js